//#region Debugger/CoreErrorHandler Comments

/* Old comments
    debugger.class.ts:
    //expected behavior test with:
//let debugTest: string = null;
//debugTest.toString();
//look for: //#debugTest

////////////////////development mode - extension:

//  Debugger.debug: appears on the console log

//  1. can be checked same time (chrome then ff)
//  BackgroundScript - init:
//      - detailed error message on console log
//  index.ts:
//      - detailed error message on welcome page
//      - detailed error message on welcome page console log
//      - detailed error message on popup page
//      - detailed error message on popup page console log
//  ContentScript - init:
//      - detailed error message on the browser tab
//      - detailed error message on the browser tabconsole log

//  2. can be checked same time (chrome then ff)
//  PopupComponent - constuctor:
//      - detailed error message on popup page
//      - detailed error message on popup page console log

//  3. can be checked same time (chrome then ff)
//  BackgroundScript - browser.runtime.onMessage.addListener:
//      - detailed error message on console log
//      - detailed error message on popup page in the catch
//  ContentScript - browser.runtime.onMessage.addListener:
//      - detailed error message on the browser tab
//      - detailed error message on the browser tabconsole log
//      - detailed error message on popup page in the catch

//  4. can be checked same time (chrome then ff)
//  MainTabComponent -  send_testValue_StoragePropertyValueToContentScript.then():
//      - detailed error message on popup page
//      - detailed error message on popup page console log

////////////////////production mode - extension:

//  Debugger.debug: doesn't appears on the console log, only the Debugger.error

//  1. can be checked same time (chrome then ff)
//  BackgroundScript - init:
//      - detailed error message on console log
//  index.ts:
//      - short error message (only app_name_snake_case + 'error_happened' message, because there is no translation here yet) on welcome page
//      - detailed error message on welcome page console log
//      - short error message (only app_name_snake_case + 'error_happened' message, because there is no translation here yet) on popup page
//      - detailed error message on popup page console log
//  ContentScript - init:
//      - no error message on the browser tab
//      - detailed error message on the browser tabconsole log

//  2. can be checked same time (chrome then ff)
//  PopupComponent - constuctor:
//      - short error message (only app name + 'An error happened' message) on popup page
//      - detailed error message on popup page console log

//  3. can be checked same time (chrome then ff)
//  BackgroundScript - browser.runtime.onMessage.addListener:
//      - detailed error message on console log
//      - short error message (only app name + 'An error happened' message) on popup page in the catch
//  ContentScript - browser.runtime.onMessage.addListener:
//      - no error message on the browser tab
//      - detailed error message on the browser tabconsole log
//      - short error message (only app name + 'An error happened' message) on popup page in the catch

//  4. can be checked same time (chrome then ff)
//  MainTabComponent - then:
//      - short error message (only app name + 'An error happened' message) on popup page
//      - detailed error message on popup page console log

////////////////////development mode - website:

//  Debugger.debug: appears on the console log

//  1. can be checked same time (chrome then ff)
//  index.ts:
//      - detailed error message on home page
//      - detailed error message on home page console log

//  2. can be checked same time (chrome then ff)
//  HomePage - constuctor:
//      - detailed error message on popup page
//      - detailed error message on popup page console log

////////////////////production mode - website:

//  Debugger.debug: doesn't appears on the console log, only the Debugger.error

//  1. can be checked same time (chrome then ff)
//  index.ts:
//      - short error message (only app name + 'error_happened' message, because there is no translation here yet) on home page
//      - detailed error message on home page console log

//  2. can be checked same time (chrome then ff)
//  HomePage - constuctor:
//      - short error message (only app name + 'An error happened' message) on home page
//      - detailed error message on home page console log
*/
//#endregion

import { IoCContainer, ITranslation, IWebCoreIoCContainer, IWebCoreSettings, WebCoreIoCKeys } from 'web-core-src';
import { IDomErrorHandler } from './dom-error-handler/dom-error-handler.interface';

// #region Enum/Class
export class ErrorResult {
    public errorName: string;
    public errorText: string;
}

export enum ApplicationType {
    webExtension,
    webExtensionContentScript,
    webExtensionBackgroundScript,
    webExtensionNewTab,
    webApplication,
}
// #endregion

export class Diagnostic {
    public static isProductionMode: boolean = true;
    public static applicationType: ApplicationType;

    // only for debugging purpose in production mode, by design this variable is false
    public static forceConsoleLogForDebugging: boolean = true;
    public static CLIENT_ERRORS_STRING: string = 'clientErrorsString';

    private static domHandler: IDomErrorHandler;

    public static init(): void {
        Diagnostic.debug('Diagnostic - init - start');

        Diagnostic.domHandler = IoCContainer.get(WebCoreIoCKeys.IDomErrorHandler);

        // in extension background worker there is no window
        if (typeof window !== 'undefined') {
            // Message: window is not defined Stack: ReferenceError: window is not defined at Diagnostic.init (chrome-
            window.addEventListener('error', (event: ErrorEvent): void => {
                Diagnostic.handleError(event);
            });
        }
        Diagnostic.debug('Diagnostic - init - end');
    }
    // #region Public methods
    public static async sleepAsync(second: number) {
        await new Promise(res => setTimeout(res, second * 1000));
    }

    public static handleError(errorObject: any): void {
        // errorhandler attached to window error, if the site or any other extensions throw an error those also raise the window.error event
        // this prevents spam with errors come from the site itself or any other extension
        if (Diagnostic.applicationType === ApplicationType.webExtensionContentScript) {
            try {
                // so many property can contains 'content-script' string, so we stringify the error object
                let errorObjectJSON: string = JSON.stringify(errorObject, ['message', 'errormessage', 'errorMessage', 'arguments', 'type', 'name', 'error', 'filename', 'fileName', 'lineno', 'colno', 'stack']);
                // we deal only exceptions from the content-script
                if (!errorObjectJSON.includes('content-script')) {
                    return;
                }
            } catch (ex) {
                console.log(ex);
            }
        }

        try {
            let errorMessage: string;

            if (errorObject instanceof ErrorEvent) {
                errorMessage = 'Message: ' + errorObject.message + '\nError: ' + errorObject.error + '\nFilename: ' + errorObject.filename + '\nLine number: ' + errorObject.lineno + '\nColumn number: ' + errorObject.colno;
            } else if (errorObject instanceof Error) {
                errorMessage = 'Message: ' + errorObject.message;
                if (errorObject.stack) {
                    errorMessage += '\nStack: ' + errorObject.stack;
                }
            } else if (errorObject instanceof Object && errorObject.message) {
                errorMessage = 'Message: ' + errorObject.message;
                if (errorObject.stack) {
                    errorMessage += '\nStack: ' + errorObject.stack;
                }
            } else if (typeof errorObject === 'string') {
                errorMessage = 'Message: ' + errorObject;
            } else {
                errorMessage = 'Developer error - Undefined error message - ErrorObject has not handled: ' + JSON.stringify(errorObject);
            }

            if (errorObject.target && errorObject.target.location && errorObject.target.location.href) {
                errorMessage += '\nerrorObject.target.location.href: ' + errorObject.target.location.href;
            }

            errorMessage += '\nCallstack: ' + Diagnostic.getCallStack();

            Diagnostic.error(errorMessage, errorObject);
        } catch (ex) {
            Diagnostic.error(ex);
        }
    }
    // ---debugger

    // #region Diagnostic functions
    public static info(messageObject?: any, ...optionalParams: any[]): void {
        if (!optionalParams) {
            optionalParams = [];
        }
        optionalParams.push(new Date());
        let messageString: string = messageObject.toString();
        console.info(messageString, optionalParams);
    }
    public static warning(messageObject?: any, ...optionalParams: any[]): void {
        if (!optionalParams) {
            optionalParams = [];
        }
        optionalParams.push(new Date());
        let messageString: string = messageObject.toString();
        console.warn(messageString, optionalParams);
    }
    // in production mode we don't write to the console anything but error
    private static error(messageObject?: any, ...optionalParams: any[]): void {
        try {
            Diagnostic.saveErrorToDom(false, messageObject, optionalParams);
            if (!optionalParams) {
                optionalParams = [];
            }
            optionalParams.push(new Date());
            optionalParams.push(messageObject);
            let messageString: string = '';
            if (messageObject.message && messageObject.stack) {
                messageString = 'Message: ' + messageObject.message + ' Stack: ' + messageObject.stack;
            } else {
                messageString = messageObject.toString();
            }
            console.error(messageString, optionalParams);
            Diagnostic.displayErrorMessage(messageString, optionalParams);
        } catch (ex) {
            let errorText: string = 'Error during errorhandling';
            console.error(errorText, ex);
            try {
                Diagnostic.displayErrorMessage(errorText, ex);
            } catch (displayEx) {
                console.error('Error during error display', displayEx);
            }
            Diagnostic.alertIfIsNotProductionMode(errorText, ex);
        }
    }

    public static saveErrorToDom(translationMissing: boolean, message?: any, ...optionalParams: any[]): void {
        Diagnostic.domHandler.saveErrorToDom(false, message, optionalParams);
    }
    // #endregion

    public static debug(message?: any, ...optionalParams: any[]): void {
        Diagnostic.debugIfIsNotProductionMode(message, optionalParams);
    }

    public static getClientDetails(): string {
        let clientDetails: string = '';

        let nAgt = navigator.userAgent;
        let browserName: string = 'unknown';
        let fullVersion: string = 'unknown';
        let majorVersion: number;
        let nameOffset: number;
        let verOffset: number;
        let ix: number;

        // In Opera, the true version is after "OPR" or after "Version"
        if ((verOffset = nAgt.indexOf('OPR')) != -1) {
            browserName = 'Opera';
            fullVersion = nAgt.substring(verOffset + 4);
            if ((verOffset = nAgt.indexOf('Version')) != -1) {
                fullVersion = nAgt.substring(verOffset + 8);
            }
        }
        // In MS Edge, the true version is after "Edg" in userAgent
        else if ((verOffset = nAgt.indexOf('Edg')) != -1) {
            browserName = 'Microsoft Edge';
            fullVersion = nAgt.substring(verOffset + 4);
        }
        // In MSIE, the true version is after "MSIE" in userAgent
        else if ((verOffset = nAgt.indexOf('MSIE')) != -1) {
            browserName = 'Microsoft Internet Explorer';
            fullVersion = nAgt.substring(verOffset + 5);
        }
        // In Chrome, the true version is after "Chrome"
        else if ((verOffset = nAgt.indexOf('Chrome')) != -1) {
            browserName = 'Chrome';
            fullVersion = nAgt.substring(verOffset + 7);
        }
        // In Safari, the true version is after "Safari" or after "Version"
        else if ((verOffset = nAgt.indexOf('Safari')) != -1) {
            browserName = 'Safari';
            fullVersion = nAgt.substring(verOffset + 7);
            if ((verOffset = nAgt.indexOf('Version')) != -1) {
                fullVersion = nAgt.substring(verOffset + 8);
            }
        }
        // In Firefox, the true version is after "Firefox"
        else if ((verOffset = nAgt.indexOf('Firefox')) != -1) {
            browserName = 'Firefox';
            fullVersion = nAgt.substring(verOffset + 8);
        }
        // In most other browsers, "name/version" is at the end of userAgent
        else if ((nameOffset = nAgt.lastIndexOf(' ') + 1) < (verOffset = nAgt.lastIndexOf('/'))) {
            browserName = nAgt.substring(nameOffset, verOffset);
            fullVersion = nAgt.substring(verOffset + 1);
        }
        // trim the fullVersion string at semicolon/space if present
        if ((ix = fullVersion.indexOf(';')) != -1) {
            fullVersion = fullVersion.substring(0, ix);
        }
        if ((ix = fullVersion.indexOf(' ')) != -1) {
            fullVersion = fullVersion.substring(0, ix);
        }

        majorVersion = parseInt('' + fullVersion, 10);

        clientDetails += 'Browser name  = ' + browserName + '\r\n' + 'Full version  = ' + fullVersion + '\r\n' + 'Major version = ' + majorVersion + '\r\n' + 'navigator.userAgent = ' + navigator.userAgent + '\r\n';

        var OSName = 'Unknown OS';
        if (navigator.userAgent.indexOf('Win') != -1) {
            OSName = 'Windows';
        }
        if (navigator.userAgent.indexOf('Mac') != -1) {
            OSName = 'Macintosh';
        }
        if (navigator.userAgent.indexOf('Linux') != -1) {
            OSName = 'Linux';
        }
        if (navigator.userAgent.indexOf('Android') != -1) {
            OSName = 'Android';
        }
        if (navigator.userAgent.indexOf('like Mac') != -1) {
            OSName = 'iOS';
        }

        clientDetails += 'OSName = ' + OSName + '\r\n';

        return clientDetails;
    }
    // #endregion

    // #region Private methods
    private static getCallStack(): string {
        const callstack: string[] = [];
        try {
            // NOTE: doesn't exist- that's the point
            throw new Error('error to get callstack');
        } catch (e) {
            if (e.stack) {
                const lines: string[] = e.stack.split('\n');
                // NOTE: start from 3 because
                // NOTE: 1 for errormessage itself
                // NOTE: 1 for getCallStack function
                // NOTE: 1 for handleError function
                for (let i: number = 3, len: number = lines.length; i < len; i++) {
                    callstack.push(lines[i].trim());
                }
            }
        }
        return callstack.join('\n');
    }

    private static debugIfIsNotProductionMode(message?: any, ...optionalParams: any[]): void {
        if (Diagnostic.forceConsoleLogForDebugging || !Diagnostic.isProductionMode) {
            if (optionalParams && optionalParams.length > 0) {
                console.debug(message, optionalParams);
            } else {
                console.debug(message);
            }
        }
    }

    private static alertIfIsNotProductionMode(errorText: string, ex: any): void {
        if (!Diagnostic.isProductionMode) {
            alert(errorText + ': ' + ex.toString());
        }
    }

    private static displayErrorMessage(message?: any, ...optionalParams: any[]): void {
        // in production mode and in case of contentScript we don't show any error to the user while he browsing
        // in the background script we can't display the errormessage anywhere
        if (Diagnostic.applicationType === ApplicationType.webExtensionBackgroundScript || (Diagnostic.applicationType === ApplicationType.webExtensionContentScript && Diagnostic.isProductionMode)) {
            return;
        }

        // on the content script the document.body sometime is null, and later it get value, so we solve this problem with an interval
        if (Diagnostic.applicationType === ApplicationType.webExtensionContentScript && !document.body) {
            let intervalId: number = window.setInterval((): void => {
                Diagnostic.displayErrorMessage(message, optionalParams);
                window.clearInterval(intervalId);
            }, 2000);
            return;
        }
        let allErrorStringList: string[] = [];
        if (!Diagnostic.isProductionMode) {
            allErrorStringList.push(message);
        }

        optionalParams.forEach((errorObject: any, index: number): void => {
            let errorStringList: string[] = Diagnostic.parseErrorToText(errorObject, index);
            allErrorStringList.push(...errorStringList);
        });

        let errorDiv: HTMLElement = document.getElementById('errorDiv');
        if (!errorDiv) {
            errorDiv = document.createElement('div');
            errorDiv.setAttribute('id', 'errorDiv');
            document.body.insertBefore(errorDiv, document.body.firstChild);
        }

        let actErrorDiv: HTMLDivElement = document.createElement('div');
        let closeButton: HTMLButtonElement = document.createElement('button');

        closeButton.style.cssFloat = 'right';
        closeButton.setAttribute('type', 'button');

        closeButton.addEventListener('click', (e: Event): boolean => {
            let button: HTMLButtonElement = <HTMLButtonElement>e.target;
            button.parentNode.parentNode.removeChild(button.parentNode);
            return false;
        });

        closeButton.innerHTML = 'x';
        actErrorDiv.appendChild(closeButton);

        allErrorStringList.forEach((errorString: string): void => {
            actErrorDiv.style.zIndex = '1000000';
            actErrorDiv.style.color = '#721c24';
            actErrorDiv.style.backgroundColor = '#f8d7da';
            actErrorDiv.style.borderColor = '#f5c6cb';
            actErrorDiv.style.position = 'relative';
            actErrorDiv.style.padding = '0.75rem 1.25rem';
            actErrorDiv.style.marginBottom = '1rem';
            actErrorDiv.style.border = '1px solid transparent';
            actErrorDiv.style.borderRadius = '0.25rem';

            actErrorDiv.appendChild(document.createTextNode(errorString));
            actErrorDiv.appendChild(document.createElement('br'));
        });

        errorDiv.appendChild(actErrorDiv);

        window.scrollTo(0, 0);
    }

    private static parseErrorToText(errorObject: any, index: number): string[] {
        const errorObjectMessage: string = 'Uncaught (in promise)';
        const rejectionTypeError: string = 'error';
        const rejectionTypeJson: string = 'application/json; charset=utf-8';

        // if the page has been loaded, but the background services tops we nahle the ajax errors here
        let serviceIsNotAvailable: boolean = errorObject.message && errorObject.message.indexOf(errorObjectMessage) !== -1 && errorObject.rejection && (errorObject.rejection.type === rejectionTypeError || errorObject.rejection.type === rejectionTypeJson);

        let errorTextList: string[] = [];

        // in production mode we only display a userfriendly message
        if (Diagnostic.isProductionMode) {
            let webCoreSettings: IWebCoreSettings = IoCContainer.get(WebCoreIoCKeys.IWebCoreSettings);

            let applicationName: string;
            if (webCoreSettings.applicationName) {
                applicationName = webCoreSettings.applicationName;
            } else {
                applicationName = webCoreSettings.applicationShortNameSnakeCase;
            }

            let webCoreIoC: IWebCoreIoCContainer = IoCContainer.get(WebCoreIoCKeys.IWebCoreIoCContainer);
            let translation: ITranslation = webCoreIoC.translation;

            let errorHappenedKey: string = 'error_messages.error_happened';
            let serviceIsNotAvailableKey: string = 'error_messages.service_is_not_available';
            if ((Diagnostic.applicationType = ApplicationType.webExtensionContentScript)) {
                errorHappenedKey = errorHappenedKey.replace('.', '__');
                serviceIsNotAvailableKey = serviceIsNotAvailableKey.replace('.', '__');
            }

            let errorHappenedTranslation: string = translation.getMessage(errorHappenedKey);
            let serviceIsNotAvailableTranslation: string = translation.getMessage(serviceIsNotAvailableKey);

            let errorHappenedText: string = applicationName + ' - ' + errorHappenedTranslation;
            errorTextList.push(errorHappenedText);
            if (serviceIsNotAvailable) {
                errorTextList.push(serviceIsNotAvailableTranslation);
            }
            return errorTextList;
        }

        // in non debug mode we parse ad display the error pobject relevant properties
        if (serviceIsNotAvailable) {
            Diagnostic.addErrorText(errorTextList, 'SERVICE IS NOT AVAILABLE', index);
            Diagnostic.addErrorText(errorTextList, 'message: ' + errorObject.message, index);
            Diagnostic.addErrorText(errorTextList, 'stack: ' + errorObject.stack, index);
        } else if (errorObject.message && errorObject.error && errorObject.error.stack) {
            Diagnostic.addErrorText(errorTextList, 'message: ' + errorObject.message, index);
            Diagnostic.addErrorText(errorTextList, 'stack: ' + errorObject.error.stack, index);
        } else if (errorObject.message && errorObject.stack) {
            Diagnostic.addErrorText(errorTextList, 'message: ' + errorObject.message, index);
            Diagnostic.addErrorText(errorTextList, 'stack: ' + errorObject.stack, index);
        } else if (errorObject.name === 'HttpErrorResponse') {
            Diagnostic.addErrorText(errorTextList, 'url: ' + errorObject.url, index);
            Diagnostic.addErrorText(errorTextList, 'status: ' + errorObject.status, index);
            Diagnostic.addErrorText(errorTextList, 'statusText: ' + errorObject.statusText, index);
            Diagnostic.addErrorText(errorTextList, 'message: ' + errorObject.message, index);
        } else {
            // Note: cache should not be re-used by repeated calls to JSON.stringify.
            let cache: any[] = [];
            Diagnostic.addErrorText(
                errorTextList,
                'ERROR: ' +
                    JSON.stringify(
                        errorObject,
                        (key: string, value: any): any => {
                            if (typeof value === 'object' && value !== null) {
                                if (cache.indexOf(value) !== -1) {
                                    // Duplicate reference found, discard key
                                    return;
                                }
                                // Store value in our collection
                                cache.push(value);
                            }
                            return value;
                        },
                        2
                    ),
                index
            );
            cache = null; // Enable garbage collection
        }

        return errorTextList;
    }

    private static addErrorText(errorTextList: string[], text: string, index: number): void {
        errorTextList.push(index + ' - ' + text);
    }
    // #endregion
}
